export function readFileContent(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.error || !reader.result) {
                reject(reader.error);
            }

            resolve(reader.result as string);
        };

        reader.readAsText(file);
    });
}
